import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  ArrowLeft, 
  ClipboardList,
  ChevronRight
} from 'lucide-react';

const PanipuravthaArthikReportDashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const reportItems = [
        { id: 'namuna-1', title: "नमुना १ (अंदाजपत्रक)", path: "/panipuravtha/financial-report/namuna-1" },
        { id: 'namuna-2', title: "नमुना २ (पुनर्विनियोजन अंदाजपत्रक)", path: "/panipuravtha/financial-report/namuna-2" },
        { id: 'namuna-3', title: "नमुना ३ (जमा व खर्च)", path: "/panipuravtha/financial-report/namuna-3" },
        { id: 'namuna-5k', title: "नमुना ५ क (दैनिक रोकड वही)", path: "#" },
        { id: 'namuna-5', title: "नमुना ५ (सामान्य रोकड वही)", path: "#" },
        { id: 'namuna-6', title: "नमुना ६ (महिन्याचे वर्गीकरण)", path: "#" },
        { id: 'namuna-7', title: "नमुना ७ (सामान्य पावती)", path: "#" },
        { id: 'namuna-12', title: "नमुना १२ (आकस्मिक खर्चाचे प्रमाणक)", path: "#" },
        { id: 'namuna-13', title: "नमुना १३ (कर्मचारी वर्गाची सुची व वेतनश्रेणी नोंद वही)", path: "#" },
        { id: 'namuna-15', title: "नमुना १५ (उपभोग वस्तु साठी लेखा नोंदवही)", path: "#" },
        { id: 'namuna-17', title: "नमुना १७ (अग्रिम दिलेल्या/ अनामत ठेवलेल्या रकमांची नोंदवही)", path: "#" },
        { id: 'namuna-18', title: "नमुना १८ (किरकोळ रोकड वही)", path: "#" },
        { id: 'namuna-19', title: "नमुना १९ (कामावर असलेल्या व्यक्तींचा हजेरीपट)", path: "#" },
        { id: 'namuna-21', title: "नमुना २१ (कर्मचा-यांच्या वेतन देयकांची नोंदवही)", path: "#" },
        { id: 'namuna-25', title: "नमुना २५ (गुंतवणुक नोंदवही)", path: "#" },
        { id: 'namuna-26k', title: "नमुना २६ क (जमा खर्चाचे मासिक विवरण)", path: "#" },
        { id: 'namuna-31', title: "नमुना ३१ (प्रवास भत्ता देयक)", path: "#" },
        { id: 'account-book', title: "खाते पुस्तिका", path: "#" },
        { id: 'monthly-income-expense', title: "महिन्याचा जमा व खर्च", path: "#" },
    ];

    return (
        <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
            {/* Header */}
            <div className="max-w-7xl mx-auto mb-10">
                <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
                    <div>
                        <h1 className="text-3xl font-bold mb-2">पाणीपुरवठा आर्थिक रिपोर्ट्स</h1>
                        <p className="text-slate-300">
                            {grampanchayatName || 'ग्रामपंचायत'} | आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                        </p>
                    </div>
                    <button
                        onClick={() => navigate(-1)}
                        className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
                    >
                        <ArrowLeft size={16} />
                        मागे जा
                    </button>
                </div>
            </div>

            {/* Reports Grid */}
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {reportItems.map((item, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            if (item.path && item.path !== '#') {
                                navigate(item.path, { state: location.state });
                            }
                        }}
                        className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 p-6 border-l-4 border-[#267c77] cursor-pointer group flex items-center justify-between"
                    >
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 rounded-full bg-[#267c77]/10 flex items-center justify-center text-[#267c77] group-hover:bg-[#267c77] group-hover:text-white transition-colors duration-300">
                                <ClipboardList className="w-6 h-6" />
                            </div>
                            <h3 className="text-lg font-semibold text-gray-800 group-hover:text-[#267c77] transition-colors">
                                {item.title}
                            </h3>
                        </div>
                        <ChevronRight className="text-gray-400 group-hover:text-[#267c77] transform group-hover:translate-x-1 transition-all" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PanipuravthaArthikReportDashboard;
